import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy route — the unified /dashboard/social-ads/create surface now owns
// the template picker inline (mirrors /dashboard/emails/create). Redirect so
// any old bookmarks land in the right place; selecting the template inline is
// the canonical flow.

export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/c/$clientId/social-ads/create-from-template/$templateId',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/o/$orgId/c/$clientId/social-ads/create',
      params: { orgId: params.orgId, clientId: params.clientId },
    });
  },
});
